"use strict";

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Tabs;

require("core-js/modules/es.regexp.to-string.js");

var _react = require("react");

var _TabsModule = _interopRequireDefault(require("../../assets/styles/components/Tabs.module.scss"));

var _gsap = _interopRequireWildcard(require("gsap"));

var _CustomEase = _interopRequireDefault(require("gsap/CustomEase"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Tabs(_ref) {
  let {
    options = [],
    onChange,
    animationSpeed = 0.3,
    ease = "linear"
  } = _ref;
  const tabs = (0, _react.useRef)([]);
  const devider = (0, _react.useRef)(null);

  _gsap.default.registerPlugin(_CustomEase.default);

  (0, _react.useEffect)(() => {
    if (Array.isArray(tabs.current) && tabs.current[0]) {
      devider.current.style.width = tabs.current[0].offsetWidth + "px";
    }
  }, [tabs]);

  const clickTab = element => {
    devider.current.style.width = element.currentTarget.offsetWidth + "px";
    let positionLeft = 0;
    let isLooping = true;

    for (let i = 0; i < tabs.current.length; i++) {
      if (tabs.current[i] !== element.currentTarget && isLooping) {
        positionLeft += tabs.current[i].offsetWidth;
      } else {
        isLooping = false;
      }
    }

    let easeVar = _gsap.Linear.easeNone;

    switch (ease.toString().toLowerCase()) {
      case "linear":
        easeVar = _gsap.Linear.easeNone;
        break;

      case "ease-out":
        easeVar = _gsap.Expo.easeOut;
        break;

      case "ease-in":
        easeVar = _CustomEase.default.create("easein", "M0,0 C0.846,0 0.944,0.548 1,1 ");
        break;

      case "back":
        easeVar = _gsap.Back.easeOut;
        break;

      default:
        easeVar = _gsap.Power0.easeOut;
        break;
    }

    const tl = _gsap.default.timeline();

    tl.to(devider.current, {
      left: positionLeft,
      duration: animationSpeed,
      ease: easeVar
    });
    const index = tabs.current.indexOf(element.currentTarget);
    onChange(options[index]);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _TabsModule.default.tabs,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _TabsModule.default.main,
      children: options.map((v, i) => {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          onClick: e => {
            clickTab(e);
          },
          ref: e => tabs.current[i] = e,
          className: _TabsModule.default.tab,
          children: v
        }, i);
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _TabsModule.default.devider,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ref: devider,
        className: _TabsModule.default.devider_active
      })
    })]
  });
}